var render = function render(){var _vm=this,_c=_vm._self._c;return _c('silo-property-form',{attrs:{"edit":false,"hide-dialog-button":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }